//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'dialog',
    event: 'input',
  },
  props: {
    dialog: Boolean,
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'width: 400px; max-width: 400px',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    disableScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qDialog: false,
    }
  },
  methods: {
    input(e) {
      if (!e) {
        this.qDialog = e
        this.$emit('input', false)
      }
    },
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.qDialog = false
      } else {
        this.qDialog = true
      }
    },
  },
}
